module.exports = __webpack_public_path__ + "static/img/h1-1.b92e6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/h1-1.png
// module id = H1tz
// module chunks = 1